import { type HTMLAttributes, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type LibraryMembersListLabelProps = HTMLAttributes<HTMLHeadingElement>;

export const LibraryMembersListLabel = memo(({ children, className, ...props }: LibraryMembersListLabelProps) => {
  return (
    <h4 className={cn('font-bold ads:text-primary text-10 text-gray-12 uppercase tracking-wide', className)} {...props}>
      {children}
    </h4>
  );
});

LibraryMembersListLabel.displayName = 'LibraryMembersListLabel';
